// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"dd31006766--tooltip--TYGif","content":"dd31006766--content--xsJCp","close":"dd31006766--close--LHCCx"};